export const getIrosUsersURL = () => process.env.REACT_APP_IROS_USERS_URL;
